import React, { useState } from 'react';
import '../../App.css';
import '../../scss/App.scss';
import '../../scss/Hotel.scss';
import { Box, Container, Grid, Link } from '@mui/material';

function Hotel() {
    const hotelCards = [
        { id: 1, title: "Apart hotel", image: "../assets/hotel/cards/discover1.svg" },
        { id: 2, title: "Apart hotel", image: "../assets/hotel/cards/discover2.svg" },
        { id: 3, title: "Apart hotel", image: "../assets/hotel/cards/discover3.svg" },
        { id: 4, title: "Apart hotel", image: "../assets/hotel/cards/discover4.svg" },
    ];

    const hotelList = [
        {
            id: 1,
            name: "Hotel Janki International",
            price: "₹1500/night",
            distance: "3.5 km from centre",
            starRating: "5 Star Hotel",
            amenities: "20+ Aminities",
            rating: "4.2",
            reviewSummary: "Very Good",
            totalReviews: "54",
            image: "../assets/hotel/hotel-card/hotel-card1.svg",
        },
        {
            id: 2,
            name: "Hotel Janki International",
            price: "₹1500/night",
            distance: "3.5 km from centre",
            starRating: "5 Star Hotel",
            amenities: "20+ Aminities",
            rating: "4.2",
            reviewSummary: "Very Good",
            totalReviews: "54",
            image: "../assets/hotel/hotel-card/hotel-card1.svg",
        },
        {
            id: 3,
            name: "Hotel Janki International",
            price: "₹1500/night",
            distance: "3.5 km from centre",
            starRating: "5 Star Hotel",
            amenities: "20+ Aminities",
            rating: "4.2",
            reviewSummary: "Very Good",
            totalReviews: "54",
            image: "../assets/hotel/hotel-card/hotel-card1.svg",
        },

        {
            id: 4,
            name: "Hotel Janki International",
            price: "₹1500/night",
            distance: "3.5 km from centre",
            starRating: "5 Star Hotel",
            amenities: "20+ Aminities",
            rating: "4.2",
            reviewSummary: "Very Good",
            totalReviews: "54",
            image: "../assets/hotel/hotel-card/hotel-card1.svg",
        },


        {
            id: 5,
            name: "Hotel Janki International",
            price: "₹1500/night",
            distance: "3.5 km from centre",
            starRating: "5 Star Hotel",
            amenities: "20+ Aminities",
            rating: "4.2",
            reviewSummary: "Very Good",
            totalReviews: "54",
            image: "../assets/hotel/hotel-card/hotel-card1.svg",
        },


        {
            id: 6,
            name: "Hotel Janki International",
            price: "₹1500/night",
            distance: "3.5 km from centre",
            starRating: "5 Star Hotel",
            amenities: "20+ Aminities",
            rating: "4.2",
            reviewSummary: "Very Good",
            totalReviews: "54",
            image: "../assets/hotel/hotel-card/hotel-card1.svg",
        },

        {
            id: 7,
            name: "Hotel Janki International",
            price: "₹1500/night",
            distance: "3.5 km from centre",
            starRating: "5 Star Hotel",
            amenities: "20+ Aminities",
            rating: "4.2",
            reviewSummary: "Very Good",
            totalReviews: "54",
            image: "../assets/hotel/hotel-card/hotel-card1.svg",
        },


        {
            id: 8,
            name: "Hotel Janki International",
            price: "₹1500/night",
            distance: "3.5 km from centre",
            starRating: "5 Star Hotel",
            amenities: "20+ Aminities",
            rating: "4.2",
            reviewSummary: "Very Good",
            totalReviews: "54",
            image: "../assets/hotel/hotel-card/hotel-card1.svg",
        },

        {
            id: 9,
            name: "Hotel Janki International",
            price: "₹1500/night",
            distance: "3.5 km from centre",
            starRating: "5 Star Hotel",
            amenities: "20+ Aminities",
            rating: "4.2",
            reviewSummary: "Very Good",
            totalReviews: "54",
            image: "../assets/hotel/hotel-card/hotel-card1.svg",
        },
    ];
     const [value, setValue] = useState('');
    const [activeTab, setActiveTab] = useState('Flights');
    return (
        <>
            <section className="hotelBanner p-0">

                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src="../assets/hotel/banner/hotel-banner.webp" className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src="../assets/hotel/banner/hotel-banner.webp" className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src="../assets/hotel/banner/hotel-banner.webp" className="d-block w-100" alt="..." />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>

            <Container maxWidth="md" className="hotelContainer">
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <div className='bannerContent'>
                            <h1>Make your travel whishlist, we’ll do the rest</h1>
                            <p>Special offers to suit your plan</p>
                        </div>
                            <div className="booking-card p-4 rounded shadow bg-white">
      <div className="tab-selector d-flex mb-3">
        <button
          className={`tab-button ${activeTab === 'Flights' ? 'active' : ''}`}
          onClick={() => setActiveTab('Flights')}
        >
          <img className="input-icon airplane" alt="icon" src="../assets/hotel/form-icon/airplane.svg" />
          Flights
        </button>
        <button
          className={`tab-button ${activeTab === 'Stays' ? 'active' : ''}`}
          onClick={() => setActiveTab('Stays')}
        >
          <img className="input-icon bed" alt="icon" src="../assets/hotel/form-icon/bed.svg" />
          Stays
        </button>
      </div>

      <h5 className="mb-4 fw-bold">Where are you rest?</h5>

      <form className="row g-3 align-items-end position-relative">
        <div className="col-md-3">
          <div className={`floating-placeholder-group ${value ? 'active' : ''}`}>
                        <img
                            src="../assets/hotel/form-icon/bed.svg"
                            className="input-icon"
                            alt="icon"
                        />
                        <input
                            type="text"
                            className="form-control"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                        <span className="floating-placeholder">Enter destination</span>
                    </div>
        </div>
        <div className="col-md-3">
          <div className={`floating-placeholder-group ${value ? 'active' : ''}`}>
                        <img
                            src="../assets/hotel/form-icon/calender.svg"
                            className="input-icon"
                            alt="icon"
                        />
                        <input
                            type="text"
                            className="form-control"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                        <span className="floating-placeholder">Check In</span>
                    </div>
        </div>
        <div className="col-md-3">
          <div className={`floating-placeholder-group ${value ? 'active' : ''}`}>
                        <img
                            src="../assets/hotel/form-icon/calender.svg"
                            className="input-icon"
                            alt="icon"
                        />
                        <input
                            type="text"
                            className="form-control"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                        <span className="floating-placeholder">Check Out</span>
                    </div>
        </div>
        <div className="col-md-3">
          <div className={`floating-placeholder-group ${value ? 'active' : ''}`}>
                        <img
                            src="../assets/hotel/form-icon/user.svg"
                            className="input-icon"
                            alt="icon"
                        />
                        <select type="text" className="form-control" value={value} onChange={(e) => setValue(e.target.value)}>
                            <option value="">1 room, 2 guests</option>
                        </select>
                    
                        <span className="floating-placeholder">1 room, 2 guests</span>
                    </div>
        </div>
        <div className='col-md-7'>

        </div>
        <div className="col-md-5">
        <div className='d-flex align-items-center justify-content-end'>
          <button className="btn btn-sm btn-primary ">
            {/* <FaHotel className="me-2" /> */}
            Show Places
          </button>
          <div className="text-end ms-3">
            <a href="#" className="text-muted small text-decoration-none">+ Add Promo Code</a>
        </div>
        </div>
        </div>

        
      </form>

      
    </div>
                        </Grid>
                     </Grid>
                 </Container>       
                
            </section>

            <section>
                <Container maxWidth="md" className="hotelContainer">
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                            <Box >
                                <h2 className="hotelH2Heading">Discover your new favourite stay</h2>
                            </Box>
                        </Grid>

                        {hotelCards.map((card) => (
                            <Grid key={card.id} size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }}>
                                <div className="card hotel-card text-white text-center">
                                    <img
                                        src={card.image}
                                        className="card-img"
                                        alt={card.title}
                                    />
                                    <div className="card-img-overlay d-flex align-items-end justify-content-center">
                                        <h5 className="card-title mb-3">{card.title}</h5>
                                    </div>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </section>

            <Container maxWidth="md" className="deals-header py-4">

                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }}>
                        <h2 className="hotelH2Heading">Top deals for a last minute getaway</h2>
                        <p className="deals-description">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </p>
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }}>
                        <div className="text-md-end text-start mt-3 mt-md-0">
                            <button className="btn btn-outline-success see-all-btn">See All</button>
                        </div>
                    </Grid>
                </Grid>
            </Container>

            <section className="cardBox p-0">
                <Container maxWidth="md" >

                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        {hotelList.map((hotel, index) => (
                            <Grid
                                key={hotel.id}
                                size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }}
                            >
                            <a href="hotel-detail" className='text-decoration-none'>
                                <div className="card">
                                    <img src={hotel.image} className="card-img-top" alt="Hotel Image" />
                                    <div className="card-body">
                                        <div className="cardPrice">
                                            <span className="hotelName">{hotel.name}</span>
                                            <div className="price">
                                                <p className='text-start'>starting from</p>
                                                <span>{hotel.price}</span>
                                                <p className='text-end'>excl. tax</p>
                                            </div>
                                        </div>
                                        <div className="cardLocation">
                                            <img src="../assets/hotel/location.svg" alt="location icon" />
                                            <span>{hotel.distance}</span>
                                        </div>
                                        <div className='reviewBox'>
                                            <Grid container spacing={2} alignItems="center">
                                                <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}>
                                                    <div className='reviewImg'>
                                                        <img src="../assets/hotel/review.svg" alt="review" />
                                                        <span>{hotel.starRating}</span>
                                                    </div>
                                                </Grid>
                                                <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                                                    <div className='aminitiesImg'>
                                                        <img src="../assets/hotel/cafe.svg" alt="amenities" />
                                                        <span>{hotel.amenities}</span>
                                                    </div>
                                                </Grid>
                                                <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                                                    <div className='totalReview'>
                                                        <p>{hotel.rating}</p>
                                                        <span><strong>{hotel.reviewSummary}</strong> {hotel.totalReviews} reviews</span>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                            <hr />
                                            <div className="viewPlace">
                                                <div className='heart'>♡</div>
                                                <a href="javascript:void(0);" className='outlineButtonGreen w-100 text-center'>View Place</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </a>
                            </Grid>
                        ))}




                    </Grid>
                </Container>
            </section>



        </>
    );
}
export default Hotel;